module.exports = __webpack_public_path__ + "img/noData.b14d222e.png";